// extracted by mini-css-extract-plugin
module.exports = {"price":"Kl-z","onSale":"Ll-z"};